import "devbridge-autocomplete/dist/jquery.autocomplete"
import { SearchSuggestionHelper } from "../helpers/searchSuggestionHelper"
class MetaSearchController {
  constructor() {
    this.load()
  }

  load() {
    $(".js-meta-search-autocomplete").autocomplete({
      lookup: this.autocompleteLookup,
      autoSelectFirst: true,
      formatResult: SearchSuggestionHelper.formatResult,
      width: 400,
      appendTo: ".js-meta-search-container",
      maxHeight: 500,
      onSelect: SearchSuggestionHelper.suggestionSelected,
      groupBy: "class_name",
      showNoSuggestionNotice: true,
      noSuggestionNotice: SearchSuggestionHelper.noSuggestionNotice,
      forceFixPosition: true,
      onSearchComplete: () => {
        $(".autocomplete-suggestions").css("opacity", "1")
      },
      onHide: () => {
        $(".autocomplete-suggestions").css("opacity", "0")
      },
    })
  }

  // We are using an arrow function to set this based on lexical scope (the class instance)
  // instead of default execution context (the calling method context ie see line 10)
  autocompleteLookup = (query, done) => {
    const ajaxQuery = "/metasearch/suggestions?query=".concat(query)
    let self = this
    $.ajax(ajaxQuery, {
      success: function (data) {
        done(self.resultsFromData(data))
      },
    })
  }

  resultsFromData = (data) => {
    return {
      suggestions: data.suggestions.map(function (suggestion) {
        return SearchSuggestionHelper.prepareResult(suggestion)
      }),
    }
  }
}

export { MetaSearchController }
